import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { ItemProductsService } from '../../../../services/api/general-settings/item-products.service';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';

@Component({
  selector: 'app-item-products-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './item-products-index-page.component.html',
  styleUrl: './item-products-index-page.component.scss'
})
export class ItemProductsIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected itemProductsService: ItemProductsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Item Products',
      cardTitle: 'Manage Item Products',
      addNewItemButton: {
        type: 'success',
        title: 'Add Item Product',
        onClick: () => {
          this.routeService.itemProductsCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),          
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            width: '50px',
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View itemProduct details',
                onClick: (item: any) => {
                  this.routeService.itemProductsDetail(item.itemProductId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit itemProduct',
                onClick: (item: any) => {
                  this.routeService.itemProductsUpdate(item.itemProductId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete itemProduct',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((itemProducts: any) => itemProducts.itemProductId !== item.itemProductId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.itemProductsService.list(options),
      responseListModelName: 'itemProducts',
    }
  }
}
